import React from 'react';
import AvatarC from '../../common/avatar';
import styles from '../agent-info/agent-info.module.scss';
import { agentInfoProps } from './agent-info.interface';

const AgentInfo = ({
  profileImg,
  title,
  name,
  email,
  phone,
  onClick,
  lastName
}: agentInfoProps) => {
  return (
    <div className={styles.agentInfo} onClick={onClick} tabIndex={26}>
      <div className={styles.title}>{title}</div>
      <div className={styles.agentWrap}>
        <AvatarC
          image={profileImg}
          label={`${name?.slice(0, 1)}${name?.split(' ')[1]?.slice(0, 1)}`}
          size='large'
          shape='circle'
        />
        <div className={styles.agentDetails}>
          {name !== undefined && <div className={styles.name}>{name}</div>}
          <div className={styles.email}>{email}</div>
          <div className={styles.phone}>{phone}</div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(AgentInfo);
